var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "#323130",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.89823 0.00684667L5 0C5.3797 0 5.69349 0.282154 5.74315 0.648229L5.75 0.75V4.25H9.25C9.6297 4.25 9.94349 4.53215 9.99315 4.89823L10 5C10 5.3797 9.71785 5.69349 9.35177 5.74315L9.25 5.75H5.75V9.25C5.75 9.6297 5.46785 9.94349 5.10177 9.99315L5 10C4.6203 10 4.30651 9.71785 4.25685 9.35177L4.25 9.25V5.75H0.75C0.370304 5.75 0.0565091 5.46785 0.00684667 5.10177L0 5C0 4.6203 0.282154 4.30651 0.648229 4.25685L0.75 4.25H4.25V0.75C4.25 0.370304 4.53215 0.0565091 4.89823 0.00684667L5 0L4.89823 0.00684667Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.49bbe96db7dff6e5ea16f3f09c81138a.svg";
export { ForwardRef as ReactComponent };